import { APIProvider } from "@vis.gl/react-google-maps";

export function GoogleMapsApiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <APIProvider
      apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      libraries={["geocoding"]}
    >
      {children}
    </APIProvider>
  );
}
